import { render } from "./ChroniclesView.vue?vue&type=template&id=7f16b460"
import script from "./ChroniclesView.vue?vue&type=script&lang=js"
export * from "./ChroniclesView.vue?vue&type=script&lang=js"

import "./ChroniclesView.vue?vue&type=style&index=0&id=7f16b460&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__